import React, { useMemo } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';

const ResponsiveGridLayout = ({ width, cols, children, breakpoints, ...rest }) => {
  const rowHeight = useMemo(() => {
    const breakpoint = Responsive.utils.getBreakpointFromWidth(breakpoints, width);
    const c = cols[breakpoint];
    // Height = parent width / number of columns / 2
    // A square is 1 width and 2 height
    return Math.max(75, width / c / 2);
  }, [width, cols, breakpoints]);

  return (
    <Responsive
      className="layout"
      compactType="vertical"
      verticalCompact
      {...rest}
      cols={cols}
      breakpoints={breakpoints}
      width={width}
      useCSSTransforms={false}
      rowHeight={rowHeight}
      style={{ zIndex: '0' }}
    >
      ``
      {children}
    </Responsive>
  );
};

export default WidthProvider(ResponsiveGridLayout);
